module.exports = __webpack_public_path__ + "img/gb973.prt.d475cd86.jpg";